/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DownloadGuardianSignature$Params {
  sessionID?: number;
}

export function DownloadGuardianSignature(http: HttpClient, rootUrl: string, params?: DownloadGuardianSignature$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, DownloadGuardianSignature.PATH, 'get');
  if (params) {
    rb.query('sessionID', params.sessionID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

DownloadGuardianSignature.PATH = '/api/Staff/DownloadGuardianSignature';
